import { Component, Provide } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';

import { getComponentProps } from '@/utils/vueUtils';

import { getStore } from '@/store/index';
import FilterableGrid from '@/modules/FilterableGridModule/FilterableGridModule.vue';

import { FilterableGridViewModel } from '@/modules/FilterableGridModule/FilterableGridModule.types';
import registerSubModule, {
  M_UPDATE_HEADER_BUTTON,
  M_HIDE_SHOW_HEADER_BUTTON,
} from '@/modules/FilterableGridModule/FilterableGridModule.store';

// import { testData, cases } from './BrochureGridModule.data';
import { mixins } from 'vue-class-component';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';
import { showToastMessage } from '@/utils/toastUtils';
import ToastType from '@/common/interfaces/enums/ToastType';
import DownloadGateMixin from '@/mixins/DownloadGateMixin';

@Component({
  props: getComponentProps<FilterableGridViewModel>({
    Header: 'Brochures',
    ShowHeaderCount: true,
    ShowLeftResultCount: false,
    HeaderCta: { Title: 'Submit Orders', Link: '#' },
    Filters: [],
    Sorting: [],
    Cards: [],
    Paging: {
      Total: 100,
      PageSize: 12,
      PageSizeMedium: 8,
      PageSizeSmall: 4,
      ViewCounts: false,
      LoadMoreButton: {
        Title: 'LOAD MORE',
        Link: '#',
        ButtonStyle: CtaButtonStyle.White,
      },
    },
    Endpoint: '/api/MarketingMaterialsService',
  }),
  components: {
    FilterableGrid,
  },
})
export default class BrochureGridModule extends mixins(StoreModuleMixin, DownloadGateMixin) {
  readonly p!: FilterableGridViewModel;

  data: FilterableGridViewModel;
  checkedBrochures: { Id: number; Qty: number }[] = [];

  async created() {
    this.data = cloneDeep(this.p);
    (this.$options as any).modulePath = await registerSubModule(getStore(), this.p);
  }

  updateButtonLink: (params: { Link: string }) => void = this.getMutation(M_UPDATE_HEADER_BUTTON);
  hideButtonLink: (isHidden: boolean) => void = this.getMutation(M_HIDE_SHOW_HEADER_BUTTON);

  @Provide()
  updateQuantity(brochureId: number, qty: number) {
    if (!this.checkedBrochures.some((c) => c.Id === brochureId)) {
      this.checkedBrochures.push({ Id: brochureId, Qty: qty });
    } else {
      this.checkedBrochures.filter((c) => c.Id === brochureId)[0].Qty = qty;
    }

    this.updateOrderButtonLink();
  }
  mounted() {
    this.updateOrderButtonLink();
  }

  updateOrderButtonLink() {
    this.hideButtonLink(this.checkedBrochures.some((b) => b.Qty > 0));
    this.updateButtonLink({ Link: this.orderBrochureUrl });
  }

  get orderBrochureUrl() {
    if (!this.p.HeaderCta) return null;
    const link = this.checkedBrochures
      .filter((c) => c.Qty > 0)
      .map((c) => ({ Id: c.Id, Count: c.Qty }));
    return `${this.p.HeaderCta.Link}?brochures=${encodeURIComponent(JSON.stringify(link))}`;
  }

  orderBrochure() {
    if (this.checkedBrochures.filter((c) => c.Qty > 0).length > 10) {
      showToastMessage([
        {
          Text: 'You may request up to 10 Brochures for each Destination',
          Type: ToastType.Error,
        },
      ]);
      return;
    }
    if (this.orderBrochureUrl) {
      window.location.href = this.orderBrochureUrl;
    }
  }
}
